// extracted by mini-css-extract-plugin
export default {"btnDelete":"modalCrachaHistorico_btnDelete__UdJDt"};